import { render, staticRenderFns } from "./CopyToClipBoard.vue?vue&type=template&id=277aac0b&scoped=true&lang=pug&"
import script from "./CopyToClipBoard.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipBoard.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipBoard.vue?vue&type=style&index=0&id=277aac0b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277aac0b",
  null
  
)

export default component.exports